(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-header-section"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false; // one add at a time -> blocks duplicate/rapid clicks

  // Persistent cart button: count badge + show/hide state.
  var fab = document.getElementById('pk-cart-fab');
  var fabCount = fab ? fab.querySelector('[data-cart-count]') : null;
  var cartOpener = null; // element that opened the drawer, for focus return on close (T08)
  function setCartCount(n) {
    n = Number(n) || 0;
    if (fabCount) fabCount.textContent = n;
    if (fab) {
      fab.classList.toggle('is-shown', n > 0);
      fab.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
      fab.setAttribute('aria-label', n > 0 ? ('Open cart, ' + n + ' item' + (n === 1 ? '' : 's')) : 'Open cart');
    }
  }
  function syncCount() {
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }

  function swapDrawer(dest, html) {
    if (!dest || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('cart-drawer') || doc.getElementById('shopify-section-cart-drawer') || doc.querySelector('.shopify-section') || doc.body;
    if (!fresh) return;
    var inner = fresh.innerHTML;
    if (!inner || !inner.trim()) return;
    if (fresh.tagName && fresh.tagName.toLowerCase() === 'cart-drawer') {
      Array.prototype.forEach.call(fresh.attributes, function (a) { try { dest.setAttribute(a.name, a.value); } catch (e) {} });
    } else {
      dest.classList.remove('is-empty', 'empty', 'cart-empty', 'drawer--empty', 'cart--empty');
    }
    dest.innerHTML = inner;
  }
  function swapBubble(html) {
    var dest = document.getElementById('cart-icon-bubble');
    if (!dest || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section') || doc.body;
    var inner = fresh ? fresh.innerHTML : '';
    if (inner && inner.trim()) dest.innerHTML = inner;
  }
  function setBusy(btn, on) {
    busy = on;
    var label = btn.querySelector('.offer-add-label');
    if (on) {
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      if (label && !btn.dataset.label) { btn.dataset.label = label.textContent; label.textContent = 'Adding\u2026'; }
    } else {
      btn.removeAttribute('aria-busy'); btn.disabled = false;
      if (label && btn.dataset.label) { label.textContent = btn.dataset.label; delete btn.dataset.label; }
    }
  }

  // Re-price the sticky bar to match the given card (variant + price label + sub-line).
  function syncSticky(card) {
    var s = document.querySelector('[data-sticky-add]');
    if (!s || !card) return;
    var cb = card.querySelector('.offer-add');
    if (cb) {
      s.setAttribute('data-variant', cb.getAttribute('data-variant') || '');
      var sl = s.querySelector('.offer-add-label'), cl = cb.querySelector('.offer-add-label');
      if (sl && cl && !cb.dataset.label) sl.textContent = cl.textContent;
    }
    var sub = document.querySelector('[data-sticky-sub]');
    if (sub) {
      var t = card.querySelector('h3'), c = card.querySelector('.offer-contents');
      sub.textContent = [t && t.textContent, c && c.textContent].filter(Boolean).join(' \u00b7 ');
    }
  }
  // Move the selected highlight to a card and re-price the sticky.
  function selectCard(card) {
    if (!card) return;
    var group = card.closest('.offers') || document;
    [].forEach.call(group.querySelectorAll('.offer-card.is-selected'), function (c) { c.classList.remove('is-selected'); });
    card.classList.add('is-selected');
    syncSticky(card);
  }

  // Click a card (anywhere except its Add button) to SELECT it — updates highlight + sticky, no add.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-add]')) return;        // the Add button is handled below
    var card = e.target.closest('.offer-card');
    if (card) selectCard(card);
  });

  // Click an Add button (card or sticky) to ADD that variant in one click.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (busy || btn.disabled) return; // already adding -> ignore duplicate clicks
    selectCard(btn.closest('.offer-card')); // a card's Add button also selects it (no-op for the sticky button)
    var variant = (btn.getAttribute('data-variant') || '').trim();
    var drawer = document.querySelector('cart-drawer');
    if (!variant) { window.location = root + 'cart'; return; }
    setBusy(btn, true);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
    }).then(function (add) {
      if (!add.ok) throw new Error('add failed');
      if (!drawer) { window.location = root + 'cart'; return null; }
      return fetch(root + '?sections=' + encodeURIComponent(SECTIONS)).then(function (r) { return r.json(); });
    }).then(function (data) {
      if (!data) return;
      swapDrawer(drawer, data['cart-drawer']);
      swapBubble(data['cart-icon-bubble']);
      syncCount();
      cartOpener = btn;
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.classList.add('active', 'is-open', 'open');
    }).catch(function () {
      window.location = root + 'cart';
    }).then(function () {
      setBusy(btn, false);
    });
  });

  // ---- Reopen-cart control: refreshes + opens the existing drawer, NEVER adds an item ----
  if (fab) {
    fab.addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) { window.location = root + 'cart'; return; }
      fetch(root + '?sections=' + encodeURIComponent(SECTIONS))
        .then(function (r) { return r.json(); })
        .then(function (data) { swapDrawer(drawer, data['cart-drawer']); swapBubble(data['cart-icon-bubble']); })
        .catch(function () {})
        .then(function () {
          cartOpener = fab;
          if (typeof drawer.open === 'function') drawer.open();
          else drawer.classList.add('active', 'is-open', 'open');
          syncCount();
        });
    });
    // Mirror every cart change (adds here + quantity edits inside the drawer).
    var themeBubble = document.getElementById('cart-icon-bubble');
    if (themeBubble && 'MutationObserver' in window) {
      new MutationObserver(function () { syncCount(); }).observe(themeBubble, { childList: true, subtree: true, characterData: true });
    }
    var drawerClose = document.querySelector('cart-drawer');
    if (drawerClose) drawerClose.addEventListener('close', syncCount);
    syncCount(); // correct the count on load
  }

  // Sticky bar visibility: show ONLY when scrolled past the fold AND nothing that hides it
  // (the hero, the buy box, or any card add button) is on screen.
  var sticky = document.getElementById('pk-sticky-cart');
  if (sticky) {
    var hideTargets = [];
    var buybox = document.getElementById('supply'); if (buybox) hideTargets.push(buybox);
    var hero = document.getElementById('top'); if (hero) hideTargets.push(hero);
    Array.prototype.push.apply(hideTargets, Array.prototype.slice.call(document.querySelectorAll('.offer-add')));
    var onScreen = new Set();
    function recompute() {
      var pastFold = window.scrollY > (window.innerHeight * 0.5);
      var show = pastFold && onScreen.size === 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (fab) fab.classList.toggle('raised', show);
    }
    if ('IntersectionObserver' in window && hideTargets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) onScreen.add(en.target); else onScreen.delete(en.target); });
        recompute();
      }, { threshold: 0 });
      hideTargets.forEach(function (t) { io.observe(t); });
    }
    var raf = false;
    window.addEventListener('scroll', function () { if (!raf) { raf = true; requestAnimationFrame(function () { raf = false; recompute(); }); } }, { passive: true });
    window.addEventListener('resize', recompute, { passive: true });
    var sel = document.querySelector('.offer-card.is-selected') || document.querySelector('.offer-card');
    if (sel) syncSticky(sel); // start the sticky matching the default selection
    recompute();
  }

  // ---- A11y (T08): when the cart drawer closes, return focus to whatever opened it
  // (the clicked purchase trigger). One observer covers the Close button, the overlay,
  // and Escape. Falls back to the visible cart button, then the theme cart link. ----
  (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    function isOpen() {
      return drawer.classList.contains('active') || drawer.classList.contains('is-open') ||
             drawer.classList.contains('open') || drawer.classList.contains('drawer--open') ||
             drawer.getAttribute('aria-hidden') === 'false' || drawer.hasAttribute('open');
    }
    function usable(el) { return !!el && el.isConnected && !el.disabled && el.getClientRects().length > 0; }
    function inView(el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      return r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw;
    }
    function focusEl(el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    function restore() {
      var target = null;
      if (usable(cartOpener) && inView(cartOpener)) target = cartOpener;          // the purchase trigger
      if (!target && usable(fab) && fab.classList.contains('is-shown')) target = fab; // visible cart control
      if (!target) {
        var bubble = document.getElementById('cart-icon-bubble');
        var link = bubble ? (bubble.closest('a') || bubble.querySelector('a')) : null;
        if (usable(link)) target = link;
      }
      if (target) focusEl(target);
      cartOpener = null;
    }
    var prevOpen = isOpen(), timer = null;
    new MutationObserver(function () {
      var open = isOpen();
      if (open === prevOpen) return;
      prevOpen = open;
      if (open) { if (timer) { clearTimeout(timer); timer = null; } return; }
      // Debounce the brief closed-flicker while we swap + reopen during an add.
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { if (!isOpen()) restore(); }, 140);
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open', 'style'] });
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
